import { render, staticRenderFns } from "./PromoTable.vue?vue&type=template&id=1f9a560a"
import script from "./PromoTable.vue?vue&type=script&lang=js"
export * from "./PromoTable.vue?vue&type=script&lang=js"
import style0 from "./PromoTable.vue?vue&type=style&index=0&id=1f9a560a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports